// extracted by mini-css-extract-plugin
module.exports = {"root":"Poster_root__mHn3r"};